import { useState } from 'react';
import { undoLastDequeue } from '../api/queue';
import type { QueueApiError } from '../api/queue';

interface Props {
  locationId: string;
  onError: (message: string) => void;
  onMutated: () => void;
}

export function QueueUndoButton({ locationId, onError, onMutated }: Props) {
  const [busy, setBusy] = useState(false);

  async function onClick() {
    if (busy) return;
    setBusy(true);
    try {
      await undoLastDequeue(locationId);
      onMutated();
    } catch (e) {
      const err = e as Partial<QueueApiError>;
      if (err.code === 'nothing_to_undo') {
        onError('Geen recente actie om ongedaan te maken (binnen 5 minuten).');
      } else {
        onError(e instanceof Error ? e.message : String(e));
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className="btn-secondary queue-undo-btn"
      disabled={busy}
      onClick={() => void onClick()}
      title="Maak de laatste verwijdering / 'markeer gestart' / start ongedaan (binnen 5 minuten)."
    >
      ↶ Ongedaan maken
    </button>
  );
}
